/* globals mapProjects */

import { Icon, Map, Marker, TileLayer } from 'leaflet'

import closeImage from './close.svg'
import markerImage from './marker.svg'

const mapElement = document.querySelector('#map')

const attribution = '© <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
const tileURL = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'

const markerIcon = new Icon({
  iconUrl: markerImage,
  iconAnchor: [21.55, 45.37],
  popupAnchor: [0, -40]
})

const closeIcon = new Icon({
  iconUrl: closeImage,
  iconAnchor: [10, 20],
  popupAnchor: [0, -40]
})

if (mapElement) {
  mapElement.classList.add('has-loaded')

  const map = new Map(mapElement, {
    center: [20, 0],
    zoom: 2,
    minZoom: 1
  })

  const tileLayer = new TileLayer(tileURL, {
    attribution,
    noWrap: true,
    bounds: [
      [-90, -180],
      [90, 180]
    ]
  })

  tileLayer.addTo(map)

  mapProjects.forEach(project => {
    const content = document.querySelector(`#${project.id}`)
    content.classList.add('is-popup')

    const marker = new Marker([project.latitude, project.longitude], {
      icon: markerIcon
    })

    marker.addTo(map)

    const popup = marker.bindPopup(content.outerHTML, { closeButton: false })

    // Hide fallback teasers.
    content.hidden = true

    popup.on('popupopen', () => {
      marker.setIcon(closeIcon)
    })

    popup.on('popupclose', () => {
      marker.setIcon(markerIcon)
    })
  })
}
